var React = require('react');

function CtaPointArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"19","cy":"19","r":"19","fill":"#FFF","key":0}),React.createElement("path",{"stroke":"#00E195","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M16 27.5l8.5-8.5-8.5-8","key":1})]));
}

CtaPointArrow.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38"};

module.exports = CtaPointArrow;

CtaPointArrow.default = CtaPointArrow;
